/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TransactionsRouteImport } from './routes/transactions'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SalariesRouteImport } from './routes/salaries'
import { Route as PlanningRouteImport } from './routes/planning'
import { Route as LicensesRouteImport } from './routes/licenses'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as ForecastRouteImport } from './routes/forecast'
import { Route as CashflowRouteImport } from './routes/cashflow'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MovementAccountIdRouteImport } from './routes/movement.$accountId'

const TransactionsRoute = TransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SalariesRoute = SalariesRouteImport.update({
  id: '/salaries',
  path: '/salaries',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanningRoute = PlanningRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => rootRouteImport,
} as any)
const LicensesRoute = LicensesRouteImport.update({
  id: '/licenses',
  path: '/licenses',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const ForecastRoute = ForecastRouteImport.update({
  id: '/forecast',
  path: '/forecast',
  getParentRoute: () => rootRouteImport,
} as any)
const CashflowRoute = CashflowRouteImport.update({
  id: '/cashflow',
  path: '/cashflow',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MovementAccountIdRoute = MovementAccountIdRouteImport.update({
  id: '/movement/$accountId',
  path: '/movement/$accountId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cashflow': typeof CashflowRoute
  '/forecast': typeof ForecastRoute
  '/invoices': typeof InvoicesRoute
  '/licenses': typeof LicensesRoute
  '/planning': typeof PlanningRoute
  '/salaries': typeof SalariesRoute
  '/settings': typeof SettingsRoute
  '/transactions': typeof TransactionsRoute
  '/movement/$accountId': typeof MovementAccountIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cashflow': typeof CashflowRoute
  '/forecast': typeof ForecastRoute
  '/invoices': typeof InvoicesRoute
  '/licenses': typeof LicensesRoute
  '/planning': typeof PlanningRoute
  '/salaries': typeof SalariesRoute
  '/settings': typeof SettingsRoute
  '/transactions': typeof TransactionsRoute
  '/movement/$accountId': typeof MovementAccountIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cashflow': typeof CashflowRoute
  '/forecast': typeof ForecastRoute
  '/invoices': typeof InvoicesRoute
  '/licenses': typeof LicensesRoute
  '/planning': typeof PlanningRoute
  '/salaries': typeof SalariesRoute
  '/settings': typeof SettingsRoute
  '/transactions': typeof TransactionsRoute
  '/movement/$accountId': typeof MovementAccountIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cashflow'
    | '/forecast'
    | '/invoices'
    | '/licenses'
    | '/planning'
    | '/salaries'
    | '/settings'
    | '/transactions'
    | '/movement/$accountId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cashflow'
    | '/forecast'
    | '/invoices'
    | '/licenses'
    | '/planning'
    | '/salaries'
    | '/settings'
    | '/transactions'
    | '/movement/$accountId'
  id:
    | '__root__'
    | '/'
    | '/cashflow'
    | '/forecast'
    | '/invoices'
    | '/licenses'
    | '/planning'
    | '/salaries'
    | '/settings'
    | '/transactions'
    | '/movement/$accountId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CashflowRoute: typeof CashflowRoute
  ForecastRoute: typeof ForecastRoute
  InvoicesRoute: typeof InvoicesRoute
  LicensesRoute: typeof LicensesRoute
  PlanningRoute: typeof PlanningRoute
  SalariesRoute: typeof SalariesRoute
  SettingsRoute: typeof SettingsRoute
  TransactionsRoute: typeof TransactionsRoute
  MovementAccountIdRoute: typeof MovementAccountIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/transactions': {
      id: '/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/salaries': {
      id: '/salaries'
      path: '/salaries'
      fullPath: '/salaries'
      preLoaderRoute: typeof SalariesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/planning': {
      id: '/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof PlanningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/licenses': {
      id: '/licenses'
      path: '/licenses'
      fullPath: '/licenses'
      preLoaderRoute: typeof LicensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forecast': {
      id: '/forecast'
      path: '/forecast'
      fullPath: '/forecast'
      preLoaderRoute: typeof ForecastRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cashflow': {
      id: '/cashflow'
      path: '/cashflow'
      fullPath: '/cashflow'
      preLoaderRoute: typeof CashflowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/movement/$accountId': {
      id: '/movement/$accountId'
      path: '/movement/$accountId'
      fullPath: '/movement/$accountId'
      preLoaderRoute: typeof MovementAccountIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CashflowRoute: CashflowRoute,
  ForecastRoute: ForecastRoute,
  InvoicesRoute: InvoicesRoute,
  LicensesRoute: LicensesRoute,
  PlanningRoute: PlanningRoute,
  SalariesRoute: SalariesRoute,
  SettingsRoute: SettingsRoute,
  TransactionsRoute: TransactionsRoute,
  MovementAccountIdRoute: MovementAccountIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
